module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-es-ES.d7d32edd.jpg";